/**
 * Models that hold data that is global or a mix
 * of global and practice-owned go in here.
 */

goog.provide('el8.data.base');
goog.provide('el8.data.allergies');
goog.provide('el8.data.apptStatuses');
goog.provide('el8.data.cptCodes');
goog.provide('el8.data.docTags');
goog.provide('el8.data.icd9Codes');
goog.provide('el8.data.icd10Codes');
goog.provide('el8.data.imos');
goog.provide('el8.data.labVendors');
goog.provide('el8.data.languages');
goog.provide('el8.data.medications');
goog.provide('el8.data.nonvisitNoteTypes');
goog.provide('el8.data.pharmacies');
goog.provide('el8.data.physicians');
goog.provide('el8.data.snomedCodes');
goog.provide('el8.data.specialtyCategories');
goog.provide('el8.data.visitNoteSectionNames');
goog.provide('el8.data.visitNoteTypes');
goog.provide('el8.data.visitNoteTemplates');
goog.provide('el8.data.patientTags');
goog.provide('el8.data.maintItemRules');
goog.provide('el8.data.bodySiteCodes');
goog.provide('el8.data.bodySiteCodeModifiers');

goog.require('el8.data.model.tag');
goog.require('el8.model.base');
goog.require('el8.shared.util.billing');
goog.require('el8.util.base');
goog.require('el8.util.string');


/**
 * These are lists of "tuples", or length-2 arrays,
 * used for dropdowns in forms typically
 */
el8.data.referralAuths = [];
el8.data.phoneTypes = [];
el8.data.races = [];
el8.data.ethnicities = [];
el8.data.sexualOrientations = [];
el8.data.genderIdentities = [];
el8.data.analyticsLabs = [];
el8.data.apptStatuses = [];
el8.data.followUpMethods = [
    'Dr. to call if results are abnormal',
    'Dr. to call if results are abnormal or not',
    'Discuss results during next office visit',
    'Dr. to send note in mail'
];
el8.data.fastingMethods = [];
el8.data.statMethods = [];
el8.data.billTypes = [];
el8.data.familyRelationships = [];

el8.data.apptInterval = null;

/**
 * This is just a regular array that holds enums shared with the server
 */
el8.data.attachablePrintouts = ['RefPanel', 'PatientDemog', 'ImmHistory', 'MedsList', 'CompMedsList',
    'WhoHeightChart', 'WhoWeightChart', 'WhoHcChart', 'CdcHeightChart', 'CdcWeightChart', 'CdcBmiChart', 'CdcHcChart'];

el8.data.specialtyCategories = (function() {
    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.addStringProperty('name');
    _class.addStringProperty('abbreviation');
    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        urlLoad: function() { return el8.service.urls.get('specialCategories'); }
    });
    that.getNameById = function(id) {
        var category = that.getById(id);
        return category ? category.getName() : that.emptyName();
    };
    that.getIdByName = function(name) {
        /* Case insensitive */
        var r = _.find(that.all(), function(a) { return a.getName().toLowerCase() === name.toLowerCase(); });
        return r ? r.getId() : null;
    };
    that.emptyName = function() { return '(Unknown)'; };
    return that;
})();

el8.data.premadeMessages = (function() {
    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.addStringProperty('btnText');
    _class.addStringProperty('body');
    return new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        urlLoad: function() { return el8.service.urls.get('premadeMessages'); }
    });
})();

el8.data.printHeaders = (function() {
    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.addStringProperty('name', true);
    _class.addStringProperty('header', true);
    // For efficiency, this is a read-only url field. The actual image must be uploaded
    // as a multipart/form-data in a separate POST request, which also sets width/height.
    _class.addStringProperty('headerImage', false);
    _class.addIntProperty('headerImageWidth', false);
    _class.addIntProperty('headerImageHeight', false);
    _class.addIntProperty('contentType', true);
    _class.addIntProperty('imagePlacement', true);
    return new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        urlLoad: function() { return el8.service.urls.get('practiceHeaders'); },
        // adding the option to explicitly sort on ID, because when we create
        // a new header, we might also get a cloned default header down, and
        // we want to make sure we respect the ID order, not the order they come down in
        sortFn: function(a, b) { return a.getId() - b.getId(); },
        saveFn: function(item, successCb, errorCb, opts) {
            $.el8_ajax({
                type: 'POST',
                url: el8.service.urls.get('practiceHeaders', [item.getId()]),
                data: JSON.stringify(item.asMap(true, false)),
                success: function(data) {
                    // data is an array of length 1-2; data[0] is the header we just requested
                    // and if data[1] exists, it's a clone of "Elation Practice Header"
                    el8.data.printHeaders.create(data);
                    item = el8.data.printHeaders.getById(data[0].id);
                    successCb(item);
                },
                error: errorCb
            });
        },
        deleteFn: function(item, successCb, errorCb, opts) {
            $.el8_ajax({
                type: 'DELETE',
                url: el8.service.urls.get('practiceHeaders', [item.getId()]),
                success: successCb,
                error: errorCb
            });
        }
    });
})();

el8.data.reportNoteTemplates = (function() {
    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.addStringProperty('text');
    return new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        urlLoad: function() { return el8.service.urls.get('reportNoteTemplates'); }
    });
})();

el8.data.visitNoteTypes = (function() {
    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.addStringProperty('name', true);
    _class.addBoolean('muOfficeVisit', true, true);
    _class.makeSortable();
    _class.makeDeleteable();

    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        saveFn: function(item, successCb, errorCb, opts) {
            $.el8_ajax({
                type: 'POST',
                url: el8.service.urls.get('visitNoteTypes', [item.getId()]),
                data: JSON.stringify(item.asMap(true)),
                success: function(data) {
                    if (item.getId()) {
                        // updates are actually delete-and-creates
                        that.updateItemId(item, data.id);
                    }
                    item.populate(data);
                    successCb(data);
                },
                error: errorCb
            });
        },
        deleteFn: function(item, successCb, errorCb, opts) {
            $.el8_ajax({
                type: 'DELETE',
                url: el8.service.urls.get('visitNoteTypes', [item.getId()]),
                success: successCb,
                error: errorCb
            });
        },
        urlFn: function(id) { return el8.service.urls.get('visitNoteTypes', [id]); },
        urlLoad: function() { return el8.service.urls.get('visitNoteTypes'); },
        urlSort: function() { return el8.service.urls.get('sortVisitNoteTypes'); }
    });
    that.makeSetSortable();

    return that;
})();

el8.data.nonvisitNoteTypes = (function() {
    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.addStringProperty('name', true);

    _class.prototype.getDisplayName = function() {
        var name = this.getName();
        if (name === 'nonvisit') {
            return 'Non-Visit';
        }
        else {
            return name.capitalize();
        }
    };

    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        urlLoad: function() { return el8.service.urls.get('nonvisitNoteTypes'); }
    });

    return that;
})();

el8.data.visitNoteSectionNames = [
    'Hpi',
    'Allergies',
    'Pe',
    'Past',
    'Surgical',
    'Family',
    'Social',
    'Habits',
    'Ros',
    'Instr',
    'Med',
    'Objective',
    'Data',
    'Assessplan',
    'Assessment',
    'Plan',
    'Test',
    'Tx',
    'Procedure',
    'Problem',
    'Followup',
    'Reason',
    'Narrative',
    'Dateprocedure',
    'Consultant',
    'Attending',
    'Referenced',
    'Orders'
];

el8.data.checklistSectionNames = [
    'Pe',
    'Ros'
];

el8.data.visitNoteTemplates = (function() {
    var _class = function(spec) {
        this.populate(spec);
        if (!spec.storeRaw) {
            this.parseContent();
        }
    };
    _class.inheritsFrom(el8_Entity);
    _class.addStringProperty('name', true);
    _class.addStringProperty('content', true);

    // The extracted data from the parsed content JSON
    _class.addProperty('billCpts', false, []);
    _class.addStringProperty('billingNotes', true);
    _class.addProperty('bulletSets', false, {});
    _class.addProperty('checklistSets', false, {});
    _class.addIntProperty('serviceLocationId', true);
    _class.addIntProperty('placeOfServiceOverride', true);
    _class.addProperty('vitalsSets', false, {});

    _class.addBoolean('shared', false);
    _class.makeDeleteable();

    _class.addDocTags();

    _class.prototype.parseContent = function() {
        try {
            var data = JSON.parse(this.getContent());
        }
        // even if we FAIL to parse the JSON, we stll go through the rest of the
        // parsing, and will get an empty template structure by the end of the fn
        catch (err) {}

        // handling normal visit note sections
        var resultBullets = {};
        var categories = el8.data.visitNoteSectionNames;

        for(var i=0; i < categories.length; i++) {
            var category = categories[i];
            var valueList = data ? data[category] : null;

            var bulletDataSet = [];
            if (valueList) {
                for(var k=0; k < valueList.length; k++) {
                    var value = valueList[k];
                    var bulletData = this.buildBulletData(category, value, null, k);
                    bulletDataSet.push(bulletData);
                }
            }

            resultBullets[category] = el8.ptdata.model.note.visitBulletSet({
                category: category,
                noteId: null
            }, bulletDataSet);
        }

        // handling checklists
        var resultChecklists = {};
        var categories = el8.data.checklistSectionNames;

        for (var i=0; i < categories.length; i++) {
            var category = categories[i];
            var valueList = data && data['checklists'] ? data['checklists'][category] : null;

            var checklistDataSet = [];
            if (valueList) {
                var checklistData = this.buildChecklistData(category, valueList);
                checklistDataSet.push(checklistData);
            }

            resultChecklists[category] = el8.ptdata.model.note.checklistSet(null, checklistDataSet);
        }

        // handling billing
        var resultBillCpts = [];

        if (data && data['billing']) {
            var that = this;
            data['billing'].forEach(function(billing) {
                var dxs = billing.dxs;
                var sequence = 0;
                dxs.forEach(function(dx) {
                    dx = that.parseBillingCptDx(dx, sequence);
                    sequence++;
                });

                var billObj = el8.ptdata.model.note.billCpt(billing);
                resultBillCpts.push(billObj);
            });
        }

        // handling doc tags
        var resultDocTagIds = [];
        if (data && data['doc_tag_ids']) { resultDocTagIds = data['doc_tag_ids']; }

        if (data && data.hasOwnProperty('billing_notes')) {
            this.setBillingNotes(data.billing_notes);
        }

        if (data && data.hasOwnProperty('service_location_id')) {
            this.setServiceLocationId(data.service_location_id);
        }

        if (data && data.hasOwnProperty('place_of_service_override')) {
            this.setPlaceOfServiceOverride(data.place_of_service_override);
        }

        this.setBillCpts(resultBillCpts);
        this.setChecklistSets(resultChecklists);
        this.setBulletSets(resultBullets);
        this.setDocTagIds(resultDocTagIds);
    };

    // used to parse billing cpt object from serialized JSON and builds proper FE model
    _class.prototype.parseBillingCptDx = function(dx, sequence) {
        dx['model_class'] = 'BillCptDx';
        dx['dx'] = '';
        dx['id'] = el8.util.generateRandomId();
        dx['sequence'] = sequence;
        if (dx['icd9_code_ids']) {
            dx['icd9_codes'] = [];
            dx['icd9_code_ids'].forEach(function(icd9_code) {
                var icd9 = el8.data.icd9Codes.getById(icd9_code);
                dx['icd9_codes'].push({
                    id: icd9.getId(),
                    model_class: 'ICD9Code',
                    code: icd9.getCode(),
                    description: icd9.getDescription()
                });
            });
        }

        if (dx['icd10_code_id']) {
            var icd10 = el8.data.icd10Codes.getById(dx['icd10_code_id']);
            dx['icd10_code'] = {
                id: icd10.getId(),
                model_class: 'ICD10Code',
                code: icd10.getCode(),
                description: icd10.getDescription()
            };
        }
        return dx;
    };

    _class.prototype.saveDocTags = function(newTagIds, opts) {
        this.setDocTagIds(newTagIds);
        if (opts.successCb) { opts.successCb(); }
    };

    _class.prototype.saveChecklistItem = function(type, item, opts) {
        // do nothing
    };

    _class.prototype.saveChecklistItems = function(type, item, opts) {
        // do nothing
    };

    _class.prototype.getCurrentEditId = function() { return; };

    // editId is ignored
    _class.prototype.getChecklists = function(type, editId) {
        var results = {};
        var checklistSet = this.getChecklistSets()[type];
        // Expect only ONE checklist per edit for now
        if (!checklistSet) { return {}; }

        if (checklistSet.all(true).length) {
            if (!editId && checklistSet.all().length > 1) {
                UIM && UIM.logError('multiple checklists: ' + this.getId() + ' ' + type);
            }
            results.current = checklistSet.sorted()[0];
        }
        return results;
    };

    // adding bullet in a visit note tmeplate, we don't deal with referenced document
    // here yet since we don't support it at this time.
    _class.prototype.addBullet = function(category, spec) {
        spec = spec || {};
        var set = this.getBulletSets()[category];
        if (set) {
            var bullet = set.create({
                'text': spec.text || '',
                'handoutId': spec.handoutId || null,
                'imoIds': spec.imoIds || null
            });
            return bullet;
        }
    };

    // adding child bullet in a visit note tmeplate, we don't deal with referenced document
    // here yet since we don't support it at this time.
    _class.prototype.addBulletChild = function(bullet, spec) {
        spec = spec || {};
        var set = bullet.getChildrenSet();
        if (set) {
            var child = set.create({
                'parentId': bullet.getId(),
                'text': spec.text || '',
                'handoutId': spec.handoutId || null
            });
            return child;
        }
    };

    // supporting function that creates the JSON data to be passed into
    // el8.ptdata.model.note.checklistSet to create the checklistSet FE data from
    // backend JSON content so we can feed into the VNT sections
    _class.prototype.buildChecklistData = function(category, fields) {
        var id = el8.util.generateRandomId();
        var checklist = {
            fields: [],
            id: id,
            type: category
        };

        var fieldKeys = Object.keys(fields);
        for(var i=0; i < fieldKeys.length; i++) {
            var fieldKey = fieldKeys[i];
            checklist.fields.push(
                el8.data.model.checklist.field({
                    sequence: i,
                    name: fieldKey,
                    value: fields[fieldKey]
                })
            );
        }

        return checklist;
    };

    // supporting function that creates the JSON data to be passed into
    // el8.ptdata.model.note.visitBulletSet to create the proper FE data from
    // backend JSON content so we can feed into the VNT sections
    _class.prototype.buildBulletData = function(category, value, parentId, sequence) {
        if (sequence === null || sequence === undefined) { sequence = 0; }
        var id = el8.util.generateRandomId();
        var bullet = {
            id: id,
            category: category,
            text: value['text'],
            imos: [],
            children: [],
            version: 1,
            sequence: sequence
        };

        if (parentId) {
            bullet['parentId'] = parentId;
        }
        if (value['imo_ids']) {
            bullet['imoIds'] = value['imo_ids'];
        }

        if (value['children']) {
            for(var j=0; j < value['children'].length; j++) {
                var child = value['children'][j];
                var childBulletData = this.buildBulletData(category, child, id, j);
                bullet['children'].push(childBulletData);
            }
        }

        return bullet;
    };

    // create a copy of this VNT, but it shall have no ID for it hasn't been
    // saved to DB. used for VNT duplication in FE
    _class.prototype.createUnsavedDuplicate = function() {
        var newVnt = el8.data.visitNoteTemplates.create({});
        newVnt.setName(this.getName() + ' Copy');
        newVnt.setContent(this.getContent());
        newVnt.parseContent();
        return newVnt;
    };

    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        urlFn: function(id) { return el8.service.urls.get('visitNoteTemplates', [id]); },
        urlLoad: function() { return el8.service.urls.get('visitNoteTemplates'); },
        saveFn: function(item, successCb, errorCb, opts) {
            $.el8_ajax({
                type: 'POST',
                url: el8.service.urls.get('visitNoteTemplates', [item.getId()]),
                data: JSON.stringify(item.asMap(true, false)),
                success: function(data) {
                    el8.data.visitNoteTemplates.create(data);
                    if (successCb) { successCb(data); }
                },
                error_msg: function(responseCode, defaultMsg) {
                    if (responseCode === 409) {
                        return "There's an existing visit note template with the same name. Please change the template name and try again.";
                    }
                    return defaultMsg;
                }
            });
        }
    });

    return that;
})();

el8.data.languages = (function() {
    var _class = function(spec) {
        this.populate(spec);
    };
    _class.inheritsFrom(el8_Entity);
    _class.addStringProperty('name', true);
    _class.addStringProperty('abbreviation', true);
    _class.prototype.asSoyMap = _class.prototype.asMap;

    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        sortFn: function(a, b) { return (a.getName()).localeCompare(b.getName()); }
    });

    /* Manually sorts common languages up-front */
    that.getPrioritizedMaps = function() {
        var priorityLanguages = ['English',
                                'Spanish; Castilian',
                                'Chinese - Mandarin',
                                'Chinese - Cantonese',
                                'Vietnamese',
                                'Declined to Specify'];
        var priorityLanguageMaps = priorityLanguages.map(function(name) {
            var lang = el8.data.languages.getByName(name);
            if (lang) { return lang.asSoyMap(); }
        });

        var otherLanguageMaps = el8.data.languages.sorted().map(function(l) {
            if (_.contains(priorityLanguages, l.getName())) { return null; }
            return l.asSoyMap();
        });

        return _.compact(priorityLanguageMaps.concat(otherLanguageMaps));
    };

    return that;
})();

el8.data.pharmacies = (function() {
    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.makeContactable();
    /**
     * NOTE: The primary key for pharmacies should be ncpdpid NOT id. It's a string!
     */
    _class.addStringProperty('ncpdpid');
    _class.addStringProperty('storeName');
    _class.addStringProperty('crossStreet');
    _class.addProperty('specialtyTypes');
    _class.addBoolean('supportsNewRx');
    _class.addBoolean('supportsRxRefill');
    _class.addBoolean('supportsControlledSubstance');

    _class.prototype.asSoyMap = function() {
        var mapped = this.parent.asSoyMap.call(this);

        mapped['name'] = this.getStoreName();
        mapped['addressLine'] = this.getAddressLine();
        mapped['cityStateZip'] = this.getCityStateZip();
        mapped['cityState'] = this.getCityState();

        return mapped;
    };
    return new el8_EntitySet({
        key: 'ncpdpid',
        model: function(spec) { return new _class(spec); },
        urlFn: function(ncpdpid) { return '/s/get/pharmacy/'+ncpdpid+'/'; }
    });
})();

el8.data.icd9Codes = (function() {
    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.addStringProperty('code');
    _class.addStringProperty('description');
    _class.prototype.getMappedSnomeds = function(callbackFn) {
        $.el8_ajax({
            type: 'GET',
            url: el8.service.urls.get('icd9ToSnomed', [this.getId()]),
            success: function(data) {
                if (data && data.length) {
                    var snomeds = el8.data.snomedCodes.create(data);
                    callbackFn(snomeds);
                }
            }
        });
    };
    return new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        items: [],
        key: 'code',
        urlFn: function() { return el8.service.urls.get('icd9Codes'); },
        urlIdFn: function(id) { return el8.service.urls.get('icd9Codes', [id]); },
        urlDataFn: function(code) { return {'code': code}; }
    });
})();

el8.data.icd10Codes = (function() {
    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.addStringProperty('code');
    _class.addStringProperty('description');
    return new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        items: [],
        key: 'code',
        urlFn: function() { return el8.service.urls.get('icd10Codes'); },
        urlIdFn: function(id) { return el8.service.urls.get('icd10Codes', [id]); },
        urlDataFn: function(code) { return {'code': code}; }
    });
})();

el8.data.hccCategory = (function() {
    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    // we want these to be serialized into the imo's soymap
    _class.addStringProperty('version', true);
    _class.addStringProperty('code', true);
    _class.addStringProperty('label', true);
    _class.addDecimalProperty('communityFactor', true);
    _class.addDecimalProperty('institutional2014Factor', true);
    _class.addDecimalProperty('communityNondualAgedFactor', true);
    _class.addDecimalProperty('communityNondualDisabledFactor', true);
    _class.addDecimalProperty('communityFbdualAgedFactor', true);
    _class.addDecimalProperty('communityFbdualDisabledFactor', true);
    _class.addDecimalProperty('communityPbdualAgedFactor', true);
    _class.addDecimalProperty('communityPbdualDisabledFactor', true);
    _class.addDecimalProperty('institutional2017Factor', true);

    // custom asSoyMap to avoid overprecision
    _class.prototype.asSoyMap = function() {
        var mapped = this.parent.asSoyMap.call(this);
        mapped['communityFactor'] = el8.util.string.reducePrecision(mapped['communityFactor']);
        mapped['institutional2014Factor'] = el8.util.string.reducePrecision(mapped['institutional2014Factor']);
        mapped['communityNondualAgedFactor'] = el8.util.string.reducePrecision(mapped['communityNondualAgedFactor']);
        mapped['communityNondualDisabledFactor'] = el8.util.string.reducePrecision(mapped['communityNondualDisabledFactor']);
        mapped['communityFbdualAgedFactor'] = el8.util.string.reducePrecision(mapped['communityFbdualAgedFactor']);
        mapped['communityFbdualDisabledFactor'] = el8.util.string.reducePrecision(mapped['communityFbdualDisabledFactor']);
        mapped['communityPbdualAgedFactor'] = el8.util.string.reducePrecision(mapped['communityPbdualAgedFactor']);
        mapped['communityPbdualDisabledFactor'] = el8.util.string.reducePrecision(mapped['communityPbdualDisabledFactor']);
        mapped['institutional2017Factor'] = el8.util.string.reducePrecision(mapped['institutional2017Factor']);
        return mapped;
    };

    return function(spec) { return new _class(spec); };
})();

el8.data.snomedCodes = (function() {
    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.addStringProperty('code');
    _class.addStringProperty('description');
    return new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        items: [],
        key: 'code',
        urlFn: function() { return el8.service.urls.get('snomedCodes'); },
        urlIdFn: function(id) { return el8.service.urls.get('snomedCodes', [id]); },
        urlDataFn: function(code) { return {'code': code}; }
    });
})();

// These are our local IMO objects
el8.data.imos = (function() {
    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);

    _class.prototype.populate = function(spec) {
        // icd10_to_hcc_lists is a list of lists since an icd10 can have multiple categories which
        // is an unusual nested model. Ids could be stored and hydrated on demand as well.
        spec.hccCategories = _.map(spec.hcc_codes, function(hccList) {
            return _.map(hccList, function(hccCat) {
                return el8.data.hccCategory(hccCat);
            });
        });

        // pre-calculate non-billable status for each ICD-10 code (as of today)
        var timeNowMs = Date.now();

        spec.icd10NonBillables = _.map(spec.icd10_effective_dates, function(period) {
            var startDate = period[0];
            var endDate = period[1];
            var isCodeInvalid = el8.shared.util.billing.isCodeNonBillable(startDate, endDate, timeNowMs);
            return isCodeInvalid;
        });

        this.parent.populate.call(this, spec);
    };

    _class.addStringProperty('code'); // IMO's id for this "lexical"

    /**
     * Whether this IMOCode is soft-deleted or not
     * NOTE: This indicates IMO vendor has updated the underlying mapping since this IMOCode was
     * first created, however, we can't assume that this IMO term contains non-billable codes.
     */
    _class.addBoolean('deleted');

    _class.addStringProperty('description'); // the primary "friendly" title of the IMO term

    _class.addIcd9s();
    _class.addProperty('icd9Descriptions', false, []);

    _class.addIcd10s();
    _class.addProperty('icd10Descriptions', false, []);
    _class.addProperty('icd10Dates', false, []);

    /**
     * List of effective start and end date periods for each ICD-10 code:
     * - Start date (YYYY-MM-DD) represents the first day that the code is valid.
     * - End date represents the day and thereafter that the code is invalid.
     * - `null` represents an unknown date.
     * @type {[string | null, string | null][]}
     */
    _class.addProperty('icd10EffectiveDates', false, []);

    /**
     * Calculated list of each ICD-10 code's non-billable status (as of today)
     * @type {boolean[]}
     */
    _class.addProperty('icd10NonBillables', false, []);

    _class.addProperty('hccCategories', true, []); // list of lists of HCCs

    _class.addStringProperty('snomed');
    _class.addStringProperty('snomedDescription');

    /* Make something that looks like BillDx soy maps:
     * Each entry in the array represents a single ICD-10 and 0-N ICD-9s.
     * In this particular case, all the codes come from a single IMO term,
     * so they'll all have the same ICD-9s. We'll only store those on the first ICD-10. */
    _class.prototype.getAsBillDxMaps = function() {
        var icd10s = _.map(_.zip(this.getIcd10Ids(), this.getIcd10Codes(), this.getIcd10Descriptions()), function(icd10) {
            return {
                id: icd10[0],
                code: icd10[1],
                description: icd10[2]
            };
        });
        var icd9s = _.map(_.zip(this.getIcd9Ids(), this.getIcd9Codes(), this.getIcd9Descriptions()), function(icd9) {
            return {
                id: icd9[0],
                code: icd9[1],
                description: icd9[2]
            };
        });
        var dxMaps = icd10s.map(function(icd10, icd10Idx) {
            var dxMap = { icd10Code: icd10 };
            if (icd9s.length && icd10Idx === 0) { dxMap.icd9Codes = icd9s; }
            return dxMap;
        });
        return dxMaps;
    };

    _class.prototype.asAutocompleteMap = function() {
        return {
            imo_code: this.getCode(),
            is_deleted: this.isDeleted(),
            title: this.getDescription(),
            icd9: this.getIcd9Codes().length ? this.getIcd9Codes()[0] : null,
            more_icd9: this.getIcd9Codes().length > 1,
            icd10: this.getIcd10Codes().length ? this.getIcd10Codes()[0] : null,
            more_icd10: this.getIcd10Codes().length > 1,
            icd10_effective_dates: this.getIcd10EffectiveDates(),
            hcc_community_factors: el8.data.practiceSettings.isHccScoringEnabled() ? this.getLatestHccFactor() : ''
        };
    };

    // custom asSoyMap required for the list of lists in HccCategories
    _class.prototype.asSoyMap = function() {
        var mapped = this.parent.asSoyMap.call(this);
        delete mapped['hccCategories'];
        mapped['hccCategories'] = this.getHccCategories().map(function(hccList) {
            return hccList.map(el8.model.toSoyMapFn);
        });
        return mapped;
    };

    // flatten out the HccCategories (a list of lists) and return soyMaps
    _class.prototype.getHccCategoriesList = function() {
        return _(this.getHccCategories()).chain()
                                         .flatten()
                                         .map(function(cat){ return cat.asSoyMap(); })
                                         .value();
    };

    _class.prototype.getLatestHccCategory = function() {
        var catList = this.getHccCategoriesList();
        // Explicitly return null if no categories
        if (_.isEmpty(catList)) {
            return null;
        }
        return _(catList).chain().sortBy('version').last().value();
    };

    _class.prototype.getLatestHccFactor = function() {
        var latest = this.getLatestHccCategory();
        if (latest) {
            return latest.communityNondualAgedFactor ? latest.communityNondualAgedFactor : null;
        }
        return null;
    };

    /**
     * Legacy helper to indicate whether this IMOCode contains at least 1 non-billable ICD code.
     * FUTURE: Refactor and determine ICD-10 code validity based on Date of Service and Payer.
     * @returns {boolean} Whether this IMOCode is entirely billable or not
     */
    _class.prototype.isImoNonBillable = function() {
        var isSomeCodeNonBillable = _.some(
            this.getIcd10NonBillables(),
            function (isInvalid) {
                return isInvalid
            }
        );
        return isSomeCodeNonBillable;
    }

    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        items: [],
        key: 'code',
        urlFn: function() { return el8.service.urls.get('fetchLocalFromImo'); },
        urlIdFn: function(id) { return el8.service.urls.get('fetchLocalFromImo', [id]); },
        urlDataFn: function(code) { return {'code': code}; }
    });

    /**
     * Get IMOCode from cache by key with freshness checks:
     * 1. If IMO->ICD10 mapping is soft-deleted in our DB, then a newer mapping likely exists in IMO ->
     *    invalidate the local cache.
     * 2. If an expected ICD-10 code isn't found among the mappings, then the cache is likely stale ->
     *    invalidate the local cache.
     * 3. By default, on cache miss, fetch and cache latest IMOCode and ICD10Codes from IMO.
     *
     * @param {string} key - IMO vendor code ID, e.g. "123456"
     * @param {string} [expectedIcd10Code] - Optional ICD-10 code (e.g. "R05.9") expected in mappings
     */
    that.getLatestImoByKey = function(key, expectedIcd10Code) {
        var imo = el8.data.imos.getByKey(key);
        var isImoStale = imo && imo._deleted;
        var isIcd10Missing = expectedIcd10Code && imo && imo._icd10Codes && !imo._icd10Codes.includes(expectedIcd10Code);

        if (isImoStale || isIcd10Missing) {
            el8.data.imos.remove(imo);
            imo = el8.data.imos.getByKey(key);
        }

        return imo;
    };

    // FUTURE: getSplitImoCodes() should return a more limited type for code splitting purpose only
    // that is appropriate for both VN assessments and problem list items.
    /**
     * Get split IMO lexical codes given an IMO lexical code containing multiple ICD codes.
     * @param {string} imoCode IMO lexical code (ID) for lookup (e.g. "123456")
     * @returns {ImoCoreProblemDetailItem[]} List of equivalent singular IMO lexical codes
     */
    that.getSplitImoCodes = function (imoCode) {
        var imoCodes = [];
        $.el8_ajax({
            type: 'GET',
            url: '/imo-core/lexical-codes/' + imoCode + '/split-codes/',
            async: false,
            success: function (data) {
                imoCodes = data;
            },
        });
        return imoCodes;
    }

    return that;
})();

// These are just practice-local "preferred" CPTs right now.
//
el8.data.cptCodes = (function() {
    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.addStringProperty('code', true);
    _class.addStringProperty('description', true);
    _class.addDecimalProperty('charge', true);
    _class.addIntProperty('sequence');

    var that =  new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        urlLoad: function() { return el8.service.urls.get('cptCodes'); },
        urlFn: function(id) { return el8.service.urls.get('cptCodes', [id]); },
        sortFn: function(a, b) { return a.getSequence() - b.getSequence(); },
        saveFn: function(item, successCb, errorCb, opts) {
            $.el8_ajax({
                type: 'POST',
                url: el8.service.urls.get('cptCodes', [item.getId()]),
                data: JSON.stringify(item.asMap()),
                success: function(data) {
                    item.populate(data);
                    successCb(data);
                },
                error: errorCb,
                error_msg: function(responseCode, defaultMsg) {
                    if (responseCode === 409) {
                        return 'This CPT code already exists in your practice. Please edit the existing "'+
                                item.getCode()+'" entry instead of creating a new one.';
                    }
                    return defaultMsg;
                }
            });
        },
        deleteFn: function(item, successCb, errorCb, opts) {
            $.el8_ajax({
                type: 'DELETE',
                url: el8.service.urls.get('cptCodes', [item.getId()]),
                success: successCb,
                error: errorCb
            });
        }
    });
    that.reOrder = function(idList, successCb, errorCb, opts) {
            var data = {'sequence':idList};
            $.el8_ajax({
                type: 'POST',
                url: el8.service.urls.get('cptCodesReorder'),
                data: JSON.stringify(data),
                success: function(data) {
                    that.create(data);
                    if (successCb) { successCb(data); }
                },
                error: errorCb
            });
    };

    // Helper fn to parse the code into the base code and modifiers
    //
    // Returns an array of the captured results with the base
    // code as the first and any modifiers following or null
    //
    // Examples:
    // input: '3008F' returns: ['3008F']
    // input: '3008F-2P' returns: ['3008F', '2P']
    // input: '3008F-2P-XX-YY-ZZ' returns: ['3008F', '2P', 'XX', 'YY', 'ZZ']
    that.parse = function(code) {
        var re = /(\w{5})-?(\w{2})?-?(\w{2})?-?(\w{2})?-?(\w{2})?/;
        var match = code.match(re);
        if (match) {
            return _.tail(match);
        }
        return null;
    };

    return that;
})();

/**
 * This largely represents "contacts" but is named "physicians" for historical reasons
 */
el8.data.physicians = (function() {
    var _class = function(spec) {
        spec['model_class'] = 'Physician';
        this.populate(spec);
    };
    _class.inheritsFrom(el8_Entity);
    _class.makeContactable();
    _class.addIntProperty('userId');
    _class.addStringProperty('contactType', true); // 'physician' or 'medical_group'

    /**
     * Choices: mapped, pending, failed, na, found_alternate
     */
    _class.addStringProperty('mappingState');

    _class.addStringProperty('fullAddress');
    // address, city, state, zip, etc. defined by makeContactable()

    /* These fields only have data when contact_type='Physician' */
    _class.addStringProperty('firstName', true);
    _class.addStringProperty('middleName', true);
    _class.addStringProperty('lastName', true);

    /* These fields contains the medical group's name when contact_type='MedicalGroup'
     * and contains the entire Physician's name when contact_type='Physician' */
    _class.addStringProperty('fullName'); // fn, ln
    _class.addStringProperty('reverseName'); // ln, fn

    _class.addStringProperty('credentials', true);
    _class.addStringProperty('email', true);
    _class.addStringProperty('directAddress', true);
    _class.addBoolean('lite'); // indicates not a complete download

    // The "access" part is a bit of a misnomer now, but basically these
    // are the elation user/practice/enterprise IDs, which might reference
    // free EMR or paid EMR accounts
    _class.addIntProperty('accessUserId');
    _class.addIntProperty('accessPracticeId');
    _class.addIntProperty('accessEnterpriseId');
    _class.addBoolean('accessPracticePlr');
    _class.addBoolean('accessPracticePracticingEmr');
    _class.addStringProperty('accessPracticeFax');

    _class.addStringProperty('deaNumber');
    _class.addStringProperty('licenseNumber');
    _class.addStringProperty('dpsNumber'); // only relevant for Texas
    _class.addStringProperty('rxAuthNumber'); // for NPs / PAs

    _class.addStringProperty('npiNumber'); // the official NPI used for stuff like ePrescribing / med order print form
    _class.addStringProperty('cmsNpi', true); // a user-selectable / potentially dirty NPI, used for contacts
    _class.addIntProperty('canonicalId');

    _class.addProperty('specialties');

    _class.addStringProperty('ssClinicName');
    _class.addProperty('ssSpecialtyTypes');

    // phone and fax defined by makeContactable()
    _class.addStringProperty('cellPhone', true);
    _class.addStringProperty('backOfficePhone', true);
    _class.addStringProperty('notes', true);
    _class.addBoolean('eConfirmed');

    // the next two properties are ints rather than bools b/c we need to preserve
    // the difference null and 0/false and our bool properties don't do that
    _class.addIntProperty('acceptingNewPatients');
    _class.addIntProperty('acceptingInsurance');
    _class.addStringProperty('insuranceAccepted');

    _class.prototype.asSoyMap = function() {
        var mapped = this.parent.asSoyMap.call(this);
        mapped['name'] = this.getFullName(); // this is bad... but it's a legacy expecation in many templates
        mapped['isNotMapped'] = !this.isMapped();
        mapped['isOrg'] = this.isMedicalGroup();
        mapped['isPcp'] = this.isPcp();
        return mapped;
    };

    /* This needs to be kept in sync with _contact_from_index in autocomplete.py
     * (at least for any variables that get used by the mindreader template) */
    _class.prototype.asSolrMap = function() {
        var soyMap = this.asSoyMap();
        var mapped = el8.util.keysFromCamelToUnderscore(soyMap);
        mapped['npi'] = mapped['cms_npi'];
        mapped['specialty'] = mapped['specialty_name'];
        mapped['address'] = mapped['full_address'];
        return mapped;
    };

    _class.prototype.isMedicalGroup = function() {
        return this.getContactType() === 'medical_group';
    };
    _class.prototype.isMapped = function() {
        return this.getMappingState() === 'mapped';
    };

    _class.prototype.isPcp = function() {
        if (el8.ptdata.currPatient && el8.ptdata.currPatient.getPcpCanonicalId() &&
            el8.ptdata.currPatient.getPcpCanonicalId() === this.getCanonicalId()) {
            return true;
        } else {
            return false;
        }
    };

    /* Get public_access_user_id (determine if we can send Via Elation to this user)
     * and provider_logo (determine what kind of logo they get) */
    _class.prototype.getPublicAccessUserInfo = function() {
        var publicAccessUserInfo;
        $.el8_ajax({
            type: 'GET',
            async: false,
            url: '/physicians/'+this.getId()+'/passport-info/',
            success: function(data) {
                publicAccessUserInfo = data;
            },
            error_override: function() {
                el8.uiwidget.alert('Sorry, this contact has been merged with another contact or deleted!');
                publicAccessUserInfo = {};
            }
        });
        return publicAccessUserInfo;
    };

    var _model = function(spec) { return new _class(spec); };

    var _set = new el8_EntitySet({
        model: _model,
        items: [],
        urlFn: function(id) { return '/physicians/'+id+'/'; }
    });

    var createLocalPhysician = function(postDict, opts) {
        opts = opts || {};
        var physician = null;
        $.el8_ajax({
            type: 'POST',
            async: (opts.async === true), // defaults to false, i.e. sync
            url: el8.service.urls.get('connections'),
            data: JSON.stringify(postDict),
            success: function(data) {
                physician = el8.data.physicians.create(data);
                if (opts.successCb) { opts.successCb(physician); }
            },
            error: opts.errorCb,
            error_override: function(data) {
                var stale_npi_error = "Cannot create a connection for this provider"
                if (data.responseText && data.responseText == stale_npi_error) {
                    el8.uiwidget.alert(stale_npi_error);
                }
                else {
                    el8.uiwidget.alert(el8.util.consts.DEFAULT_ERROR_MSG);
                }
            }
        });
        /* Only can return non-null if opts.async != true, which is default */
        return (opts.async === true) ? null : physician;
    };
    _set.physicianFromCanonical = function(canonicalId, opts) {
        return createLocalPhysician({ profile_id: canonicalId }, opts);
    };
    _set.physicianFromNpi = function(npi, opts) {
        return createLocalPhysician({ npi: npi }, opts);
    };

    return _set;
})();

el8.data.allergies = (function() {
    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.addStringProperty('name');
    _class.addStringProperty('type');
    _class.addBoolean('userCreated');
    _class.addStringProperty('medispanid');

    var _model = function(spec) { return new _class(spec); };

    return new el8_EntitySet({
        key: 'name',
        model: _model,
        items: [],
        urlFn: function(id) {return '/get/allergy/'+id+'/';}
    });
})();

//
// Health Maint Item Rules - "mixed" global and practice-createable
//
el8.data.maintItemRules = (function() {
    //
    // maintItemRuleReason
    //
    // Pseudo-entity for CQM result reasons for the rules below. This is the vector
    // for information about entities that ambiently satisfy rules. See CQMResultReason.
    //
    // These create "virtual" HM items for display
    //
    var _reason = function(spec) {
        this.populate(spec);
        this.setModelClass('maintItemRuleReason');
    };
    _reason.inheritsFrom(el8_Entity);
    _reason.addStringProperty('description'); // Reason in the BE. Flattened here
    _reason.addStringProperty('identifier'); // same
    _reason.addDate('date');
    _reason.addIntProperty('sourceId');
    _reason.addStringProperty('codeType');
    _reason.addStringProperty('code');
    _reason.addBoolean('exclusionItem');
    // values -- unused

    //
    // maintItemRules
    //
    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);

    _class.addStringProperty('name');
    _class.addStringProperty('status');
    _class.addIntProperty('cqmId');
    _class.addProperty('docTagIds', true, []); // ordered by sequence
    _class.addModelSetProperty('reasons', function(spec) { return new _reason(spec); }, true, []);
    _class.addBoolean('showResultFlag');
    _class.addStringProperty('abnormalResultFlagText');
    _class.addStringProperty('normalResultFlagText');

    var _model = function(spec) { return new _class(spec); };

    var that = new el8_EntitySet({
        key: 'name',
        model: _model,
        items: [],
        urlLoad: function() { return el8.service.urls.get('maintItemRules'); }
    });

    // New CQM infrastructure needs to instantiate this directly to interface with the HM system
    // See maintItems.js
    that.maintItemRuleReason = _reason;

    return that;
})();

el8.data.medications = (function() {
    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);

    _class.addStringProperty('displayName');
    _class.addStringProperty('cleanName');
    _class.addStringProperty('brandName');
    _class.addStringProperty('genericName');
    _class.addStringProperty('form');
    _class.addStringProperty('route');
    _class.addStringProperty('strength');
    _class.addBoolean('controlled');
    // the exceptoins states below are the states that deviate from the federal definition
    _class.addProperty('controlledExceptionStates', false, []);
    _class.addStringProperty('creationType');

    _class.addIntProperty('score');
    _class.addBoolean('lite');
    _class.addStringProperty('medispanddid');
    _class.addIntProperty('deaSchedule');

    _class.addIntProperty('preferredAltId');
    _class.addStringProperty('preferredAltSig');

    _class.addStringProperty('type'); // Notice that this 'type' can be NULL
    _class.prototype.isPrescription = function() { return this.getType() === 'prescription'; };
    _class.prototype.isOtc = function() { return this.getType() === 'otc'; };
    _class.prototype.isUserCreated = function() { return this.getCreationType() === 'user'; };
    _class.prototype.isDispensable = function() { return this.getCreationType() === 'disp'; };

    _class.prototype.shouldBePrescribedInML = function() {
        // Note: the list of routes that count as "fluid" was invented by
        // Phill and is a best-attempt. Notably present in our database for
        // some Oral medications but absent from this list are:
        //     Concentrate, Gel, Tincture, Emulsion, Paste
        return Boolean(
            this.getRoute() === 'Oral'
            && this.getForm()
            && ["LIQUID", "SUSPENSION", "LIQUID ER",
                "SUSPENSION ER", "SYRUP", "SOLUTION", "ELIXIR",
                "OIL", "FLUID EXTRACT"].includes(
                    this.getForm().toUpperCase()
                ));
    }

    _class.prototype.asSoyMap = function() {
        var mapped = this.parent.asSoyMap.call(this);

        mapped['isPrescription'] = this.isPrescription();
        mapped['isOtc'] = this.isOtc();
        mapped['isUserCreated'] = this.isUserCreated();
        mapped['isDispensable'] = this.isDispensable();

        return mapped;
    };

    _class.prototype.getFriendlyType = function() {
        if (this.getType() === 'prescription') { return 'rx'; }
        return this.getType();
    };

    _class.prototype.getFriendlyName = function() {
        return this.getBrandName() + ' ' + (this.getStrength() || '');
    };

    /**
    Determines if a medication is controlled according to the geographical state available.
     @param {string} state - if the caller passed in a null state, use practice state.
     @returns {boolean} - if a medication is controlled for a given state, or if it's federally controlled.
     */
    _class.prototype.isControlled = function(state) {
        var federalControlled = this._controlled;
        var currentState = state || el8.data.currPractice.getState();
        var exceptionStates = this.getControlledExceptionStates();
        if (exceptionStates && _.contains(exceptionStates, currentState)) {
            return true;
        } else {
            return federalControlled;
        }
    };

    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        items: [],
        urlFn: function(id) { return '/s/get/medication/'+id+'/'; },
        urlNameFn: '/s/match/medication/'
    });

    that.getByDisplayName = function (name) {
        return that.getByName(name, 'displayName');
    };

    that.getByBrandName = function (name) {
        return that.getByName(name, 'brandName');
    };

    return that;
})();

el8.data.docTags = (function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8.data.model.tag);
    _class.makeDeleteable();

    _class.addStringProperty('code', true);
    _class.addStringProperty('codeType', true);
    _class.addStringProperty('description', true);

    _class.addBoolean('shared'); // practice-global stuff is "shared"

    // used by VN and VNT to figure out what CPT we need to generate
    // when we add a particular document tag
    _class.prototype.getBillingCpt = function() {
        if (!this.getCode()) { return; }
        if (_.contains(['CPT', 'CPTII', 'HCPCS'], this.getCodeType())) {
            return this.getCode();
        }
    };

    // used by VN and VNT to figure out what Dx we need to generate
    // when we add a particular document tag
    _class.prototype.getBillingDxMap = function() {
        var _makeDxMap = function (icd10str, icd9str) {
            return {
                icd10Code: el8.data.icd10Codes.getByKey(icd10str).asSoyMap(),
                icd9Codes: [el8.data.icd9Codes.getByKey(icd9str).asSoyMap()]
            };
        };

        // Only applies to icd10-based bills
        if (this.getCodeType() === 'ICD9' && this.getCode() === 'V65.3') {
            return _makeDxMap('Z71.3', 'V65.3');
        } else if (this.getCodeType() === 'ICD9' && this.getCode() === 'V65.41') {
            return _makeDxMap('Z71.89', 'V65.41');
        }
    };

    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        urlLoad: function() { return el8.service.urls.get('documentTags'); },
        urlFn: function(id) { return el8.service.urls.get('documentTags', [id]); },
        saveFn: function(item, successCb, errorCb, opts) {
            $.el8_ajax({
                type: 'POST',
                url: el8.service.urls.get('documentTags', [item.getId()]),
                data: JSON.stringify(item.asMap(true, false)),
                success: function(data) {
                    el8.data.docTags.create(data);
                    if (successCb) { successCb(data); }
                },
                error_msg: function(responseCode, defaultMsg) {
                    if (responseCode === 409) {
                        return 'Your practice already has a tag named "'+
                            item.getValue() +'." Please choose a unique name.';
                    }
                    return defaultMsg;
                }
            });
        },
        deleteFn: function(item, successCb, errorCb, opts) {
            $.el8_ajax({
                type: 'DELETE',
                url: el8.service.urls.get('documentTags', [item.getId()]),
                success: successCb,
                error: errorCb
            });
        }
    });

    that.fetchByCodes = function(codes, successCb) {
        $.el8_ajax({
            type: 'GET',
            url: el8.service.urls.get('documentTagsByCodes'),
            data: {'codes[]': codes},
            success: function(data) {
                var tags = that.create(_.values(data));
                var tagIds = tags.map(function(t) { return t.getId(); });
                successCb(tagIds);
            }
        });
    };

    // Used for adding CDS doc tags to a note
    that.fetchByConceptNames = function(conceptNames, successCb) {
        $.el8_ajax({
            type: 'GET',
            url: el8.service.urls.get('documentTagConcepts'),
            data: {'concept_name[]': conceptNames},
            success: function(data) {
                // We're just going to assume the client wants
                // to take action on all of these tags,
                // without caring which is which or about order.
                // If that changes, it has the data to change that.
                var tags = that.create(_.values(data));
                var tagIds = tags.map(function(t) { return t.getId(); });
                successCb(tagIds);
            }
        });
    };

    /*
     * This duplicates fetchByConceptNames, except for calling V2 of
     * documentTagConcepts, because the behavior of documentTagConcepts
     * is incorrect for use by clinical reminders (it returns soft-deleted
     * doc tags that don't work with the corresponding clinical measure).
     * This V2 of the function will not return any soft-deleted doc tags.
     */
    that.fetchByConceptNamesV2 = function(conceptNames, successCb) {
        $.el8_ajax({
            type: 'GET',
            url: el8.service.urls.get('documentTagConceptsV2'),
            data: {'concept_name[]': conceptNames},
            success: function(data) {
                // We're just going to assume the client wants
                // to take action on all of these tags,
                // without caring which is which or about order.
                // If that changes, it has the data to change that.
                var tags = that.create(_.values(data));
                var tagIds = tags.map(function(t) { return t.getId(); });
                successCb(tagIds);
            }
        });
    };
    return that;

})();

el8.data.patientTags = (function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8.data.model.tag);
    _class.makeDeleteable();

    _class.addBoolean('shared'); // practice-global stuff is "shared"

    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        urlLoad: function() { return el8.service.urls.get('availablePtTags'); },
        urlFn: function(id) { return el8.service.urls.get('availablePtTags', [id]); },
        saveFn: function(item, successCb, errorCb, opts) {
            $.el8_ajax({
                type: 'POST',
                url: el8.service.urls.get('availablePtTags', [item.getId()]),
                data: JSON.stringify(item.asMap(true, false)),
                success: function(data) {
                    el8.data.patientTags.create(data);
                    if (successCb) { successCb(data); }
                },
                error_msg: function(responseCode, defaultMsg) {
                    if (responseCode === 409) {
                        return 'Your practice already has a patient tag named "' +
                            item.getValue() + '." Please choose a unique name.';
                    }
                    return defaultMsg;
                }
            });
        },
        mergeFn: function(itemId, mergeItemIds, successCb, errorCb, opts) {
            $.el8_ajax({
                type: 'POST',
                url: el8.service.urls.get('mergePtTags', [itemId]),
                data: {'items': mergeItemIds},
                success: successCb,
                error: errorCb
            });
        },
        deleteFn: function(item, successCb, errorCb, opts) {
            $.el8_ajax({
                type: 'DELETE',
                url: el8.service.urls.get('availablePtTags', [item.getId()]),
                success: successCb,
                error: errorCb
            });
        }
    });

    return that;

})();

el8.data.labVendors = (function() {
    // Replaces Ancillary companies in lab order form and settings
    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.addStringProperty('name');
    _class.addStringProperty('displayName');
    _class.addBoolean('hasOrderCompendium');
    _class.addBoolean('isInHouse');

    _class.prototype.getDefaultLabCompendiumId = function() {
        return this.rawData.default_compendium? this.rawData.default_compendium.id : null;
    };

    return new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        sortFn: function(a, b) { return el8.util.string.cmp(a.getDisplayName().toLowerCase(),
                                                            b.getDisplayName().toLowerCase()); },
        urlLoad: function() { return el8.service.urls.get('labVendors');},
        urlIdFn: function(id) { return el8.service.urls.get('labVendors', [id]); }
    });

})();

el8.data.labVendorPatientSites = (function() {
    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.addIntProperty('vendorId');
    _class.addStringProperty('name');

    _class.addStringProperty('address');
    _class.addStringProperty('suite');
    _class.addStringProperty('city');
    _class.addStringProperty('state');
    _class.addStringProperty('zip');
    _class.addStringProperty('phone');
    _class.addStringProperty('fax');

    _class.prototype.getDescription = function() {
        var description = this.getName();
        if (this.getCity() && this.getAddress()) {
            description += ": " + this.getCity() + ' - ' + this.getAddress();
        }
        return description;
    };

    var that =  new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        urlLoad: function() { return el8.service.urls.get('labVendorPatientSites');},
        urlIdFn: function(id) { return el8.service.urls.get('labVendorPatientSites', [id]); },
        sortFn: function(a,b) {
            return el8.util.string.cmp(a.getDescription(), b.getDescription());
        }
    });


    that.getByVendorId = function(vendorId) {
        return _.filter(el8.data.labVendorPatientSites.sorted(), function(site) { return site.getVendorId() === vendorId; });
    };

    return that;
})();

el8.data.bodySiteCodes = (function() {
    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.addStringProperty('code');
    _class.addStringProperty('text');

    return new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        sortFn: function(a, b) { return el8.util.string.cmp(a.getText().toLowerCase(),
                                                            b.getText().toLowerCase()); },
        key: 'code',
        urlLoad: function() { return el8.service.urls.get('bodySiteCodes');}
    });
})();

el8.data.bodySiteCodeModifiers = (function() {
    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.addStringProperty('code');
    _class.addStringProperty('text');

    return new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        sortFn: function(a, b) { return el8.util.string.cmp(a.getText().toLowerCase(),
                                                            b.getText().toLowerCase()); },
        key: 'code',
        urlLoad: function() { return el8.service.urls.get('bodySiteCodeModifier');}
    });
})();
